import { ReactComponent as DenmarkFlagComponent } from '../assets/flags/denmark.svg'
import { ReactComponent as FinlandFlagComponent } from '../assets/flags/finland.svg'
import { ReactComponent as FranceFlagComponent } from '../assets/flags/france.svg'
import { ReactComponent as GermanyFlagComponent } from '../assets/flags/germany.svg'
import { ReactComponent as LuxembourgFlagComponent } from '../assets/flags/luxembourg.svg'
import { ReactComponent as MoroccoFlagComponent } from '../assets/flags/morocco.svg'
import { ReactComponent as NetherlandFlagComponent } from '../assets/flags/netherland.svg'
import { ReactComponent as NorwayFlagComponent } from '../assets/flags/norway.svg'
import { ReactComponent as SwedenFlagComponent } from '../assets/flags/sweden.svg'
import { ReactComponent as TunisiaFlagComponent } from '../assets/flags/tunisia.svg'
import { ReactComponent as UkFlagComponent } from '../assets/flags/unitedKingdom.svg'

export const getCountryFlagComponent = (code: string) => {
  switch (code.toLowerCase()) {
    case 'nb':
    case 'no':
      return <NorwayFlagComponent className="w-4 h-4" />
    case 'en':
      return <UkFlagComponent className="w-4 h-4" />
    case 'fi':
      return <FinlandFlagComponent className="w-4 h-4" />
    case 'dk':
      return <DenmarkFlagComponent className="w-4 h-4" />
    case 'sv':
    case 'se':
      return <SwedenFlagComponent className="w-4 h-4" />
    case 'fr':
      return <FranceFlagComponent className="w-4 h-4" />
    default:
      return <UkFlagComponent className="w-4 h-4" />
  }
}

export const FlagIconOnCountryPrefix = ({ phonenumber }: { phonenumber: string }) => {
  const prefix = phonenumber.startsWith('+') ? '+' : phonenumber.startsWith('00') ? '00' : undefined
  if (!prefix) return null
  if (phonenumber.startsWith(prefix + '46')) {
    return <SwedenFlagComponent className="w-5 h-5" />
  } else if (phonenumber.startsWith(prefix + '47')) {
    return <NorwayFlagComponent className="w-5 h-5" />
  } else if (phonenumber.startsWith(prefix + '45')) {
    return <DenmarkFlagComponent className="w-5 h-5" />
  } else if (phonenumber.startsWith(prefix + '358')) {
    return <FinlandFlagComponent className="w-5 h-5" />
  } else if (phonenumber.startsWith(prefix + '44')) {
    return <UkFlagComponent className="w-5 h-5" />
  } else if (phonenumber.startsWith(prefix + '33')) {
    return <FranceFlagComponent className="w-5 h-5" />
  } else if (phonenumber.startsWith(prefix + '49')) {
    return <GermanyFlagComponent className="w-5 h-5" />
  } else if (phonenumber.startsWith(prefix + '216')) {
    return <TunisiaFlagComponent className="w-5 h-5" />
  } else if (phonenumber.startsWith(prefix + '352')) {
    return <LuxembourgFlagComponent className="w-5 h-5" />
  } else if (phonenumber.startsWith(prefix + '212')) {
    return <MoroccoFlagComponent className="w-5 h-5" />
  } else if (phonenumber.startsWith(prefix + '31')) {
    return <NetherlandFlagComponent className="w-5 h-5" />
  }
  return null
}
